module.exports = __webpack_public_path__ + "static/praktijk2-6cfd1f4b8a84c2cfda57f99b5401b414.jpg";